import {Component, Input, OnInit} from '@angular/core';
import {Safeguard} from '../../../class/result/safeguard/safeguard';
import {Person} from '../../../class/person';
import {AbstractQuoteComponent} from '../abstract-quote-component';

@Component({
  selector: 'app-safeguard-quote',
  templateUrl: './safeguard-quote.component.html',
  styleUrls: ['./safeguard-quote.component.css']
})
export class SafeguardQuoteComponent extends AbstractQuoteComponent implements OnInit {

  @Input()
  safeguardResult: Safeguard;

  isEditing = false;

  constructor() {
    super();
  }

  ngOnInit() {
  }
}
